import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { FDBox } from '@facet-wealth/design';
import { EmailVerificationSentLayoutContainer } from './emailVerificationSentLayoutContainer';
import { overrides } from './overrides';

const EmailVerificationSentTemplate = ({
  resource,
}) => {
  return (
    <MetaFormInline
      metaOverrideSet={overrides}
      component={FDBox/* Allows the background to be visible, removes padding */}
      resource={resource}
      layout={EmailVerificationSentLayoutContainer}
      noIndividualSubmitButtons
    />
  );
};

EmailVerificationSentTemplate.defaultProps = {
};

EmailVerificationSentTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default EmailVerificationSentTemplate;
